// Design confirm specs (Manage Events Screen (15) ME:516-539). "Set Back to
// Draft" (Scheduled, Cancelled) has no design confirm; it keeps a production
// safety confirm (Q11).
export type ConfirmableAction = "cancel" | "close" | "delete" | "setDraft" | "unpublish" | "publish" | "unschedule";
export const confirmSpecs: Record<ConfirmableAction, {
  title: string;
  confirmLabel: string;
  bodyPre: string;
  bodyPost: string;
  iconPaths: string[];
  done: (name: string) => string;
  tone: "red" | "gold" | "green";
}> = {
  cancel: {
    title: "Cancel Event",
    confirmLabel: "Yes, Cancel Event",
    bodyPre: "Are you sure you want to cancel ",
    bodyPost: "? Attendees will no longer be able to register.",
    iconPaths: ["M12 2a10 10 0 1 0 0 20 10 10 0 1 0 0-20", "m15 9-6 6", "m9 9 6 6"],
    done: (name) => `${name} has been cancelled successfully.`,
    tone: "red",
  },
  // Manage Events Screen (21) ME:683-686 (Monday 13332118523, 13327100066).
  close: {
    title: "Close Event Registration",
    confirmLabel: "Close Event Registration",
    bodyPre: "Are you sure you want to close event registration for ",
    bodyPost:
      "?\n\nOnce closed, event registration will no longer be available on the website event page. The event page will say Sold Out, and the event will show on the website until 11:59 PM on the event date. Tickets can be sold through the dashboard only, based on availability.",
    iconPaths: ["M5 11h14a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2Z", "M7 11V7a5 5 0 0 1 10 0v4"],
    done: (name) => `Event registration for ${name} has been closed successfully.`,
    tone: "red",
  },
  delete: {
    title: "Delete Event",
    confirmLabel: "Yes, Delete Event",
    bodyPre: "Are you sure you want to delete ",
    bodyPost: "? This action cannot be undone.",
    iconPaths: ["M3 6h18", "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6", "M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2", "M10 11v6", "M14 11v6"],
    done: (name) => `${name} has been deleted successfully.`,
    tone: "red",
  },
  setDraft: {
    title: "Set Back to Draft",
    confirmLabel: "Yes, Set to Draft",
    bodyPre: "Are you sure you want to set ",
    bodyPost: " back to draft? It will no longer show on your website.",
    iconPaths: ["M12 20h9", "M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z"],
    done: (name) => `${name} has been set back to draft.`,
    tone: "gold",
  },
  // Manage Events Screen (16) publish (Draft rows).
  publish: {
    title: "Publish Event",
    confirmLabel: "Yes, Publish",
    bodyPre: "Are you sure you want to publish ",
    bodyPost: "? It will appear on your website and open for registration right away.",
    iconPaths: ["M22 2 11 13", "M22 2 15 22 11 13 2 9 22 2"],
    done: (name) => `${name} has been published successfully.`,
    tone: "green",
  },
  // Manage Events Screen (16) unschedule (Scheduled rows).
  unschedule: {
    title: "Unschedule Event",
    confirmLabel: "Yes, Unschedule",
    bodyPre: "Are you sure you want to unschedule ",
    bodyPost: "? It will no longer publish automatically and will be reverted back to Draft. Existing registrations and sponsorships are kept.",
    iconPaths: ["M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", "M3 3v5h5"],
    done: (name) => `${name} has been unscheduled and set back to Draft.`,
    tone: "red",
  },
  // Manage Events Screen (15) ME:536-539.
  unpublish: {
    title: "Unpublish Event",
    confirmLabel: "Yes, Unpublish",
    bodyPre: "Are you sure you want to unpublish ",
    bodyPost: "? It will be removed from your website and reverted back to Draft. Existing registrations and sponsorships are kept.",
    iconPaths: ["M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", "M3 3v5h5"],
    done: (name) => `${name} has been unpublished and reverted back to Draft.`,
    tone: "red",
  },
};

export const isConfirmableAction = (action: string): action is ConfirmableAction =>
  action in confirmSpecs;
